module.exports = __webpack_public_path__ + "static/media/tree1.204532e6.jpg";